import React, { useContext } from "react";
import { Wrapper, Headers } from "./style";
import NewRelease from "../../components/NewRelease";
import { ThemeContext } from "../../ThemedContext/Provider";

const AllAlbums = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper themes={theme}>
      <Headers></Headers>
      <NewRelease subTitle='All Album' />
    </Wrapper>
  );
};

export default AllAlbums;
